import { render, staticRenderFns } from "./FinancialService2.vue?vue&type=template&id=535863d5"
import script from "./FinancialService2.vue?vue&type=script&lang=js"
export * from "./FinancialService2.vue?vue&type=script&lang=js"
import style0 from "./FinancialService2.vue?vue&type=style&index=0&id=535863d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports